import { NgModule } from '@angular/core';
import { SwitchboardComponent } from './switchboard.component';
import { IvrComponent } from './ivr/ivr.component';
import { SipTrunkComponent } from './siptrunk/sip-trunk.component';
import { QueueComponent } from './queue/queue.component';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { Select2Module } from 'ng2-select2';
import { QueueService } from '../../../../../common/services/Queue.service';
import { ServiceService } from '../../../../../common/services/Service.service';
import { ComponentsModule } from '../../../../../components/component.module';
import { RouterModule } from '@angular/router';
import { ScriptComponent } from './ivr/script/script.component';
import { ListComponent } from './ivr/script/list/list.component';
import { DetailComponent } from './ivr/script/detail/detail.component';
import { AudioComponent } from './ivr/audio/audio.component';
import { CustomFormsModule } from 'ng2-validation';

@NgModule({
  imports: [BrowserModule, FormsModule, Select2Module, ComponentsModule, RouterModule, CustomFormsModule],
  declarations: [
    SwitchboardComponent,
    IvrComponent,
    SipTrunkComponent,
    QueueComponent,
    ScriptComponent,
    ListComponent,
    DetailComponent,
    AudioComponent,
  ],
  exports: [SwitchboardComponent],
  providers: [QueueService, ServiceService],
})
export class SwitchboardModule {}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/switchboard.module.ts